import * as React from 'react';
import classNames from 'classnames';
import SvgSprite from 'src/react/components/html-elements/SvgSprite';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';

var AvatarBadge = function AvatarBadge(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? Variant.primary : _ref$style;

  if (!icon && typeof text === 'undefined') {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames("avatar-badge badge badge-pill badge-".concat(style), {
      'badge-square': icon
    })
  }, text !== null && text !== void 0 ? text : /*#__PURE__*/React.createElement(SvgSprite, {
    id: icon,
    size: 10
  }));
};

export { AvatarBadge };